<template>
  <v-dialog v-model="dialog" max-width="720">
    <v-card>
      <v-toolbar color="primary" dark dense>
        <v-icon left>
          mdi-file-document-outline
        </v-icon>
        <span class="text-subtitle-2">
          {{ details ? details.title : 'Source Details' }}
          <span v-if="details && details.reference"> — {{ details.reference }}</span>
        </span>
        <v-spacer />
        <v-btn icon small @click="dialog = false">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text v-if="details" class="pt-4">
        <v-row dense>
          <v-col
            v-for="(value, label) in details.info"
            :key="label"
            cols="6"
            sm="4"
          >
            <div class="text-caption grey--text">
              {{ label }}
            </div>
            <div class="text-body-2 font-weight-medium">
              {{ value }}
            </div>
          </v-col>
        </v-row>
        <v-simple-table v-if="details.items.length" dense class="mt-2">
          <template #default>
            <thead>
              <tr>
                <th class="text-left">
                  Product
                </th>
                <th class="text-left">
                  Brand
                </th>
                <th class="text-right">
                  Price
                </th>
                <th class="text-right">
                  Qty
                </th>
                <th class="text-left">
                  Unit
                </th>
                <th class="text-right">
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in details.items" :key="index">
                <td>{{ item.product }}</td>
                <td>{{ item.brand }}</td>
                <td class="text-right">
                  {{ php(item.price) }}
                </td>
                <td class="text-right">
                  {{ item.quantity }}
                </td>
                <td>{{ item.unit }}</td>
                <td class="text-right">
                  {{ php(item.amount) }}
                </td>
              </tr>
              <tr>
                <td colspan="5" class="text-right font-weight-bold">
                  Total
                </td>
                <td class="text-right font-weight-bold">
                  {{ php(details.total) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { authAxios } from '@/extra-functions/axios.extra'
import { ErrorPopup, LoadingPopup } from '@/lib/utils'

export default {
  name: 'SourceRefDialog',
  data() {
    return {
      dialog: false,
      details: null,
    }
  },
  methods: {
    async open(journalId) {
      try {
        LoadingPopup.fire('Retrieving source details...')
        const { data } = await authAxios().get(
          `/v2/inventory-journals/${journalId}/source`,
        )
        this.details = data
        LoadingPopup.close()
        this.dialog = true
      } catch (e) {
        console.error(e)
        LoadingPopup.close()
        ErrorPopup.fire('Failed to load source details.')
      }
    },
    php(val) {
      return Number(val || 0).phpFormat()
    },
  },
}
</script>
